export enum AccountType {
    Uknonwn = 'Unknown',
    Invoice = 'Invoice',
    Team = 'Team',
    GroupIncome = 'GroupIncome',
    Person = 'Person',
    GroupSavings = 'GroupSavings',
    GroupOverflow = 'GroupOverflow',
}
